import { PrivateSettings } from '@wix/wix-vod-gql-api/dist/src/private/settings/settings';
import { privateClient } from './client';
export var vodSettingsService = new PrivateSettings(privateClient);
